// Vertical Mode Floating Menu
(function() {
  // Only run in vertical mode
  function isVerticalMode() {
    return document.documentElement.classList.contains('display-vertical');
  }

  if (!isVerticalMode()) {
    return;
  }

  console.log('[VerticalMenu] Initializing vertical menu dock');

  const menu = document.getElementById('vertical-floating-menu');
  if (!menu) {
    console.log('[VerticalMenu] Menu element not found');
    return;
  }

  const catalogButton = menu.querySelector('[data-vertical-menu-catalog]');
  const cartButton = menu.querySelector('[data-vertical-menu-cart]');
  const searchButton = menu.querySelector('[data-nt-open="search"]');
  const clearCartButton = menu.querySelector('[data-vertical-menu-clear-cart]');
  const backButton = menu.querySelector('[data-vertical-menu-back]');

  // Open catalog (trigger mobile menu) - Toggle functionality 
  function openCatalog(e) {
    e.preventDefault();

    const mobileDrawer = document.querySelector('.t_n__mobile_drawer');
    const mobileToggle = document.querySelector('[data-mobile-toggle]');

    if (!mobileDrawer || !mobileToggle) {
      console.warn('[VerticalMenu] New mobile menu not found');
      return;
    }

    const isOpen = mobileDrawer.classList.contains('is-active');

    if (isOpen) {
      mobileToggle.click();
      return;
    }

    const searchDrawer = document.getElementById('SearchDrawer');

    if (searchDrawer && searchDrawer.hasAttribute('open')) {
      if (typeof searchDrawer.hide === 'function') {
        searchDrawer.hide();
      } else {
        searchDrawer.removeAttribute('open');
      }
    }

    const cartDrawer = document.getElementById('CartDrawer');

    if (cartDrawer && cartDrawer.hasAttribute('open')) {
      if (typeof cartDrawer.hide === 'function') {
        cartDrawer.hide();
      } else {
        cartDrawer.removeAttribute('open');
      }

      setTimeout(() => {
        mobileToggle.click();
      }, 300);

      return;
    }

    mobileToggle.click();
  }

  // Helper function to open the catalog menu
  function openCatalogMenu() {
    const mobileMenuBtn = document.querySelector('.ntm__hamb');
    if (mobileMenuBtn) {
      mobileMenuBtn.click();
    } else {
      console.warn('[VerticalMenu] Mobile menu button not found');
    }
  }

  // Clear cart
  async function clearCart(e) {
    e.preventDefault();
    
    if (!confirm('¿Estás seguro de que quieres vaciar el carrito?')) {
      return;
    }

    console.log('[VerticalMenu] Clearing cart');
    
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        console.log('[VerticalMenu] Cart cleared successfully');
        // Reload the page to reflect changes
        window.location.reload();
      } else {
        throw new Error('Failed to clear cart');
      }
    } catch (error) {
      console.error('[VerticalMenu] Error clearing cart:', error);
      alert('Hubo un error al vaciar el carrito. Por favor, inténtalo de nuevo.');
    }
  }

  // Go back
  function goBack(e) {
    e.preventDefault();
    console.log('[VerticalMenu] Going back');
    window.history.back();
  }

  // Open cart drawer
  function openCartDrawer(e) {
    e.preventDefault();

    const cartTrigger = document.querySelector('[data-t_n-open="cart"]');

    if (!cartTrigger) {
      console.warn('[VerticalMenu] Cart trigger not found');
      return;
    }

    const searchDrawer = document.getElementById('SearchDrawer');

    if (searchDrawer && searchDrawer.hasAttribute('open')) {
      if (typeof searchDrawer.hide === 'function') {
        searchDrawer.hide();
      } else {
        searchDrawer.removeAttribute('open');
      }
    }

    const mobileDrawer = document.querySelector('.t_n__mobile_drawer');
    const mobileToggle = document.querySelector('[data-mobile-toggle]');

    if (mobileDrawer && mobileDrawer.classList.contains('is-active')) {
      mobileToggle.click();

      setTimeout(() => {
        cartTrigger.click();
      }, 300);

      return;
    }

    cartTrigger.click();
  }

  // Helper function to open the cart drawer
  function openCartDrawerHelper() {
    const cartDrawerButton = document.querySelector('[aria-controls="CartDrawer"]');
    if (cartDrawerButton) {
      cartDrawerButton.click();
    } else {
      console.warn('[VerticalMenu] Cart drawer button not found');
      window.location.href = '/cart';
    }
  }

  // Open search drawer
  function openSearchDrawer(e) {
    e.preventDefault();

    const searchTrigger = document.querySelector('[data-t_n-open="search"]');

    if (!searchTrigger) {
      console.warn('[VerticalMenu] Search trigger not found');
      return;
    }

    const cartDrawer = document.getElementById('CartDrawer');

    if (cartDrawer && cartDrawer.hasAttribute('open')) {
      if (typeof cartDrawer.hide === 'function') {
        cartDrawer.hide();
      } else {
        cartDrawer.removeAttribute('open');
      }
    }

    const mobileDrawer = document.querySelector('.t_n__mobile_drawer');
    const mobileToggle = document.querySelector('[data-mobile-toggle]');

    if (mobileDrawer && mobileDrawer.classList.contains('is-active')) {
      mobileToggle.click();

      setTimeout(() => {
        searchTrigger.click();
      }, 300);

      return;
    }

    searchTrigger.click();
  }
 
  // Dock menu is always visible, no collapsed state needed

  // Event listeners

  if (catalogButton) {
    catalogButton.addEventListener('click', openCatalog);
  }

  if (cartButton) {
    cartButton.addEventListener('click', openCartDrawer);
  }

  if (searchButton) {
    searchButton.addEventListener('click', openSearchDrawer);
  }

  if (clearCartButton) {
    clearCartButton.addEventListener('click', clearCart);
  }

  if (backButton) {
    backButton.addEventListener('click', goBack);
  }

  console.log('[VerticalMenu] Vertical menu dock initialized successfully');
})();
